import { faCheckCircle, faChevronDown, faChevronUp, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Badge, Card, Col, Collapse, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { snakeToTitleCase } from "../../../../utils/string-utils";
import { EvidenceModal } from "../common/EvidenceModal";
import { Evidence, renderMatchDetails, VerificationState } from "../common/verification";
import { LabsModal } from "../../Labs";
import { EvidenceBlock } from "../common/EvidenceBlock";
import { LLMDashboardMarkdownRenderer } from "../common/LLMDashboardMarkdownRenderer";

export const SectionDDXDetails = (props: {
    idx: number,
    data: any,
    scanMulti: any,
}) => {

    const [targetEvidence, setTargetEvidence] = useState<Evidence>();
    const [showEvidenceIndex, setShowEvidenceIndex] = useState<number | null>(null);
    const [verificationState, setVerificationState] = useState<VerificationState>();

    return (
        <Card className="notes-section-details">
            <Card.Body>
                {
                    props.data && (
                        <>
                            <Row>
                                <Col md={10}>
                                    <strong>#{props.idx + 1} {props.data.diagnosis}</strong>
                                </Col>
                                <Col md={2} className="text-right">
                                    {
                                        props.data.high_risk && (
                                            <small><Badge bg="danger">High Risk</Badge></small>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col className="description-text">
                                    <Row>
                                        <Col className="description-heading">
                                            Likelihood
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {props.data.likelihood}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="description-text">
                                    <Row>
                                        <Col className="description-heading">
                                            Justification
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <LLMDashboardMarkdownRenderer content={props.data.justification} scanMulti={props.scanMulti} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <EvidenceBlock evidence={props.data.evidence} scanMulti={props.scanMulti} />
                        </>
                    )
                }
                {/* <LabsModal showModal={showLabsModal} setShowModal={handleShowLabsModal} labs={labsData} patientVisit={patientVisit} addAnnotationToPlots={addAnnotationToPlots} highlightedLabTime={labsModalHighlightedTime} /> */}
                {/* <EvidenceModal showModal={showEvidenceModal} setShowModal={setShowEvidenceModal} verificationState={verificationState} evidence={targetEvidence} /> */}
            </Card.Body>
        </Card>
    );
};
